// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"60b09f21","787":"4ee91f52"}[chunkId] + ".chunk.js";
};